module.exports = __webpack_public_path__ + "img/product-type-item-bg.85a32ef9.png";